import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import config from "../config";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [weekType, setWeekType] = useState("");
  const [currentClass, setCurrentClass] = useState(null);
  const [nextClass, setNextClass] = useState(null);
  const [timeUntilNextClass, setTimeUntilNextClass] = useState("");
  const [schedule, setSchedule] = useState([]);
  const [lastFetchTime, setLastFetchTime] = useState(0);

  useEffect(() => {
    updateWeekType();
    fetchSchedule();
    

    // Пересчитываем пары каждые 30 секунд
    const scheduleInterval = setInterval(() => {
      fetchSchedule();
    }, 30000);

    return () => clearInterval(scheduleInterval);
  }, []);

  useEffect(() => {
    if (schedule.length) calculateCurrentAndNextClass();
  }, [schedule, weekType]);

  const fetchSchedule = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const now = Date.now();
    if (now - lastFetchTime < 30000) return;
    setLastFetchTime(now);

    try {
      const response = await axios.get(`${config.API_URL}/schedule`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSchedule(response.data);
    } catch (error) {
      console.error("Ошибка загрузки расписания:", error);
    }
  };

  const updateWeekType = () => {
    const weekNumber = getWeekNumber(new Date());
    const type = weekNumber % 2 === 0 ? "Числитель" : "Знаменатель";
    setWeekType(type);
  };

  const getWeekNumber = (date) => {
    let d = new Date(date);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    let yearStart = new Date(d.getFullYear(), 0, 1);
    return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  };

  const calculateCurrentAndNextClass = () => {
    if (!schedule.length) return;

    const now = new Date();
    const currentWeekday = now.getDay();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const filteredSchedule = schedule
      .filter((lesson) => lesson.weekday === currentWeekday)
      .sort((a, b) => a.order - b.order);

    const numeratorClasses = filteredSchedule.filter((lesson) => lesson.is_even_week);
    const denominatorClasses = filteredSchedule.filter((lesson) => !lesson.is_even_week);

    let finalSchedule = weekType === "Числитель" ? numeratorClasses : denominatorClasses.length ? denominatorClasses : numeratorClasses;

    let current = null;
    let next = null;

    for (let lesson of finalSchedule) {
      const [startHour, startMinute] = lesson.start_time.split(":").map(Number);
      const [endHour, endMinute] = lesson.end_time.split(":").map(Number);
      const lessonStart = startHour * 60 + startMinute;
      const lessonEnd = endHour * 60 + endMinute;

      if (currentMinutes >= lessonStart && currentMinutes < lessonEnd) {
        current = lesson;
        setTimeUntilNextClass(`До конца пары осталось ${formatTime(lessonEnd - currentMinutes)}.`);
      } else if (currentMinutes < lessonStart && !next) {
        next = lesson;
        setTimeUntilNextClass(`До начала пары осталось ${formatTime(lessonStart - currentMinutes)}.`);
      }
    }

    if (!current && !next) setTimeUntilNextClass("Сегодня пар больше нет.");

    setCurrentClass(current);
    setNextClass(next);
  };

  const formatTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours > 0 ? `${hours} ч ` : ""}${mins} мин`;
  };

  return (
    <AppContext.Provider value={{ weekType, currentClass, nextClass, timeUntilNextClass, fetchSchedule }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
